import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core'
import { NgClass, NgOptimizedImage } from '@angular/common'
import { MatCheckbox } from '@angular/material/checkbox'
import { TranslationService } from '../../../../services/translation.service'
import { GhsService } from '../../../../services/ghs.service'
import { firstValueFrom } from 'rxjs'
import { GhsClassification } from '../../../../types/ghs'
import { ErrorService } from '../../../../services/error.service'
import { SpinnerService } from '../../../../services/spinner.service'
import { ApiError } from '../../../../types/apiError'
import { DialogService } from '../../../../services/dialog.service'
import { Dialog } from '@angular/cdk/dialog'

@Component({
  selector: 'app-ghs-select',
  imports: [NgOptimizedImage, MatCheckbox, NgClass],
  templateUrl: './ghs-select.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './ghs-select.component.scss',
})
export class GhsSelectComponent implements OnInit {
  protected translationService = inject(TranslationService)
  protected ghsService = inject(GhsService)
  protected errorService = inject(ErrorService)
  protected spinnerService = inject(SpinnerService)
  protected dialogService = inject(DialogService)

  @Input() selected?: Array<GhsClassification> = []
  @Output() selectChange = new EventEmitter<Array<GhsClassification>>()

  dialog = inject(Dialog)
  classifications?: Array<GhsClassification>

  async ngOnInit() {
    await this.getAllClassifications()
  }

  /**
   * Retrieve all ghs classifications from the api
   */
  async getAllClassifications() {
    try {
      this.spinnerService.startSpinner()
      this.classifications = await firstValueFrom(this.ghsService.getAll())
      this.spinnerService.stopSpinner()
    } catch (err) {
      this.spinnerService.stopSpinner()
      const apiErr = err as ApiError
      this.errorService.handleErr(this.dialogService, apiErr, this.dialog)
    }
  }

  /**
   * Determine if a ghs classification is already selected
   * @param classification
   */
  isSelected(classification: GhsClassification) {
    return this.selected?.find((selected) => selected.id === classification.id)
  }

  /**
   * Handle the selection of a classification code by code
   * @param classification
   */
  handleSelect(classification: GhsClassification) {
    if (this.isSelected(classification)) {
      this.selected = this.selected?.filter(
        (selected) => selected.id !== classification.id,
      )
    } else {
      this.selected?.push(classification)
    }

    this.selectChange.emit(this.selected)
  }
}
